import { render, staticRenderFns } from "./ConfirmSendForVerification.vue?vue&type=template&id=bb5cf178&"
import script from "./ConfirmSendForVerification.vue?vue&type=script&lang=ts&"
export * from "./ConfirmSendForVerification.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports